<div fxLayout="column">
  <div class="box">
    <mat-accordion>
      @for (data of list; track trackByFn(i, data); let i = $index) {
        <mat-expansion-panel class="mat-elevation-z0 vocacao-list" [ngClass]="{'grey-bg': data.recomendado, 'soft-grey-bg': !data.recomendado}"
          >
          <mat-expansion-panel-header class="panel-height" style="padding-left: 40px; padding-right: 40px;">
            <mat-panel-title fxLayout="row" fxLayoutGap="15px">
              <span class="body-title" fxFlex="75"> {{data.cnae}} </span>
              <div fxFlex="5">
                <div class="data-vocacao-header">Peso</div>
                <span>-</span>
              </div>
              <div fxFlex="15">
                <div class="data-vocacao-header">Representatividade</div>
                <span class="representatividade-value">{{ data.representatividade | percent: '1.2-2' }}</span>
              </div>
              <div fxFlex="5" class="soma-vocacoes-column">
                <div class="data-vocacao-header">Soma</div>
                <span class="soma">{{ data.soma | percent: '1.2-2' }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div fxLayout="column" fxLayoutGap="10px" class="vocacao-detail">
            <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="center">
              <div class="vocacao-detail-header">
                <div class="vocacao-detail-header-margin">
                  <div fxFlex="20"></div>
                  <div fxFlex="20" class="header-table-detalhes-vocacao">Empresas</div>
                  <div fxFlex="20" class="header-table-detalhes-vocacao">Grandes Empresas</div>
                  <div fxFlex="20" class="header-table-detalhes-vocacao">Empregos</div>
                  <div fxFlex="20" class="header-table-detalhes-vocacao">VAF</div>
                </div>
              </div>
              <div class="vocacao-detail-body">
                <div class="vocacao-detail-body-margin" fxLayout="row">
                  <span fxFlex="20" fxLayoutAlign="end" style="font-weight: bold;">Total</span>
                  <span fxFlex="20" class="txt-center">{{data.totalEmpresas}}</span>
                  <span fxFlex="20" class="txt-center">{{data.totalGrandesEmpresas}}</span>
                  <span fxFlex="20" class="txt-center">{{data.totalEmpregos}}</span>
                  <span fxFlex="20" class="txt-center">{{data.totalVaf | number: '1.2-2'}}</span>
                </div>
              </div>
              <div class="vocacao-detail-body">
                <div class="vocacao-detail-body-margin" fxLayout="row">
                  <span fxFlex="20" fxLayoutAlign="end" style="font-weight: bold;">Representatividade</span>
                  <span fxFlex="20" class="txt-center">{{data.representatividadeEmpresas !== null ?
                  (data.representatividadeEmpresas | percent: '1.2-2') : '---'}}</span>
                  <span fxFlex="20" class="txt-center">{{data.representatividadeGrandesEmpresas !== null ?
                  (data.representatividadeGrandesEmpresas | percent: '1.2-2') : '---'}}</span>
                  <span fxFlex="20" class="txt-center">{{data.representatividadeEmpregos !== null ?
                  (data.representatividadeEmpregos | percent: '1.2-2') : '---'}}</span>
                  <span fxFlex="20" class="txt-center">{{data.representatividadeVaf !== null ?
                  (data.representatividadeVaf | percent: '1.2-2') : '---'}}</span>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
</div>
